import { Injectable } from "@angular/core";
import { DataService } from "@app/core/services/data.service";
import { TwoRewardAccount } from "@app/models";

import { Observable } from "rxjs";
import { map, mergeMap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class TwoRewardService {
  private serviceUrl = "TwoRewardPlatform";
  constructor(private http: DataService) {}
  getAccount(accountId: string): Observable<TwoRewardAccount> {
    return this.http.get(`${this.serviceUrl}/getAccount/${accountId}`);
  }
  getAccountByUsername(username: string): Observable<TwoRewardAccount> {
    return this.http.get(`${this.serviceUrl}/getAccountByUsername/${username}`);
  }
  getAllAccounts(): Observable<TwoRewardAccount[]> {
    return this.http.get(`${this.serviceUrl}/getAccounts`);
  }
  createAccount(userId: number, account: TwoRewardAccount): Observable<TwoRewardAccount> {
    return this.http.post(`${this.serviceUrl}/createAccount/${userId}`, account);
  }
  updateAccount(account: TwoRewardAccount): Observable<TwoRewardAccount> {
    return this.http.post(`${this.serviceUrl}/updateAccount`, account);
  }
  deleteAccount(externalId: string): Observable<TwoRewardAccount> {
    return this.http.post(`${this.serviceUrl}/deleteAccount/${externalId}`);
  }
}
